<template>
  <a-modal
    class="report_content m-1"
    :centered="true"
    :width="586"
    v-model="show"
    :footer="null"
    :closable="false"
  >
    <div class="d-flex pt12">
      <font-awesome-icon
        class="error500 bg-error50 rounded-circle font30 p20"
        :icon="['fas', 'exclamation-triangle']"
      />
      <div class="ml-3 flex1">
        <h4 class="mb-3 text-capitalize font24 fw700 gray700">
          {{ actionText }} {{ confirmText }}?
        </h4>
        <p class="mb-0 gray500 font16">
          Are you sure you want to {{ actionText }} this {{ confirmText }}?
          <br />
          {{ canUndo ? "" : "You can’t undo this action." }}
        </p>
        <div class="mt-5 gap24 d-flex">
          <button
            :style="{ border: 'none' }"
            class="p1224 br6 bg-gray200 fw700 font14 gray600 ml-auto"
            @click="hide"
          >
            Cancel
          </button>
          <a-button
            :loading="loading"
            :style="{ border: 'none', background: getPrimaryColor() }"
            class="p1224 br6 fw700 font14 text-white text-capitalize"
            @click="apply"
          >
            {{ actionText }}
          </a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "GenericConfirmModal",
  props: {
    confirm_text: {
      type: String,
      default: "post"
    },
    action_text: {
      type: String,
      default: "delete"
    },
    handleConfirm: Function,
    canUndo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      data: null,
      loading: false,
      actionText: "delete",
      confirmText: "post"
    };
  },
  mounted() {
    this.actionText = this.action_text;
    this.confirmText = this.confirm_text;
  },
  methods: {
    open(data = null) {
      this.show = true;
      this.data = data;
    },
    hide() {
      this.show = false;
      this.loading = false;
      this.data = null;
    },
    apply() {
      this.loading = true;
      this.handleConfirm(this.data);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modals/GenericConfirmModal.vue